import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { NgxSpinnerService } from 'ngx-spinner';

import {
  BackendService,
  ModalService,
  NotificationService,
  TableActionParams,
} from 'beyond-util';

import { SifarnikBase } from '../sifarnik-base/sifarnik-base';
import { BackendService as RtsBackendService } from '../../../services/backend.service';
import { FormCode } from '../../../enums/form-code.enum';
import { FormName } from '../../../enums/form-name.enum';
import { EndpointTypes } from '../../../enums/enpoint-types.enum';
import { EnumService } from '../../../services/enum.service';

@Component({
  selector: 'app-vrste-spota',
  templateUrl: './vrste-spota.component.html',
})
export class VrsteSpotaComponent extends SifarnikBase
  implements OnInit, OnDestroy {
  private _subscriptions: Subscription[] = [];
  private _data: any[];

  constructor(
    protected _backendService: BackendService,
    protected _modalService: ModalService,
    protected _notificationService: NotificationService,
    private _rtsBackendService: RtsBackendService,
    private _enumService: EnumService,
    private _spinner: NgxSpinnerService
  ) {
    super(_backendService, _modalService, _notificationService);
  }

  ngOnInit() {
    setTimeout(() => {
      this._spinner.show();
      super.ngOnInit();
      this._enumService.fetchMedijumi();
    });
  }

  ngOnDestroy() {
    this._subscriptions.forEach((s: Subscription) => s.unsubscribe());
  }

  loadSettings() {
    this._subscriptions.push(
      this._rtsBackendService
        .fetchSettings(
          FormCode.MSSPO_VRSP,
          FormName.SifarnikVrstaSpota,
          EndpointTypes.AllEntities,
          this.filterQuery
        )
        .subscribe(data => {
          this._spinner.hide();
          const settings = this.forbidActions(data['Settings']);
          if (!this.settingsTable) {
            this.setSettings(settings);
          }
          this._data = data['ServiceData'];
          this.orderList = this.setRbr([...this._data]);
          this.setAllFields();
        })
    );
  }

  forbidActions(settings: any) {
    settings.additable = false;
    settings.editable = false;
    settings.deletable = false;
    settings.inlineAdding = false;
    settings.inlineEditing = false;

    return settings;
  }

  refreshTable() {
    this.orderList = this.setRbr(this._data);
  }

  addOrder() {
    this._spinner.show();
    const payload = { ...this.order };
    this._subscriptions.push(
      this._rtsBackendService
        .save(FormCode.MSSPO_VRSP, FormName.PregledSpotova, payload)
        .subscribe(data => {
          this.getServiceErrorMessage(data);
          this.loadSettings();
          this._enumService.fetchVrstaSpota(true);
        })
    );
  }

  getServiceErrorMessage(data) {
    if (data['Error'] && data['Error']['ErrorMessage']) {
      this._notificationService.notyError(data['Error']['ErrorMessage']);

      return;
    }
  }

  updateOrder() {
    this._spinner.show();
    const payload = { ...this.order };
    this._subscriptions.push(
      this._rtsBackendService
        .update(FormCode.MSSPO_VRSP, FormName.PregledSpotova, payload)
        .subscribe(data => {
          this.getServiceErrorMessage(data);
          this.loadSettings();
          this._enumService.fetchVrstaSpota(true);
        })
    );
  }

  onDeleteConfirm() {
    this._spinner.show();
    this._subscriptions.push(
      this._rtsBackendService
        .delete(FormCode.MSSPO_VRSP, FormName.PregledSpotova, this.order.Id)
        .subscribe((data: any) => {
          if (data.ServiceData) {
            this._notificationService.openNoty('Uspešno brisanje');
          } else {
            this._notificationService.openNoty('Nije moguće obrisati stavku.');
          }
          this.loadSettings();
          this._enumService.fetchVrstaSpota(true);
        })
    );
  }

  onTableActionUpdate(event: TableActionParams) {
    super.onTableActionUpdate(event);
    this.updateOrder();
  }

  onTableActionFilter(event: any) {
    this._spinner.show();
    super.onTableActionFilter(event);
  }

  onTableInlineSave(event) {
    this.addOrder();
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/sifarnici/vrste-spota/vrste-spota.component.ts